type NODE_ENV = "production" | "development";

const config = {
  env: (process.env.NODE_ENV ?? "production") as NODE_ENV,
  api: import.meta.env.VITE_REACT_APP_API_URL ?? "https://api.kamae.io",
  app: import.meta.env.VITE_REACT_APP_APP_URL ?? "https://admin.kamae.io",
};

export default config;
